module.exports = __webpack_public_path__ + "img/logoNavbar.a29a430c.png";